import React from 'react';
import FacilityRadio from './FacilityRadio/FacilityRadio';
import './styles.scss';

class RadioList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataList: [],
    };
  }

  componentDidMount() {
    this.setDataList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataList !== this.props.dataList) {
      this.setDataList();
    }
  }

  setDataList = () => {
    let dataList = this.props.dataList;
    dataList = dataList.map((facility) => ({
      ...facility,
      isChecked:
        facility.facilityName === this.props.selectedValue ? true : false,
    }));
    this.setState({ dataList });
  }

  render() {
    return (
      <div className="radio-list-wrapper">
        {this.state.dataList.map((facility) => (
          <FacilityRadio
            {...facility}
            defaultValue={this.props.selectedValue}
            onFacilityChange={this.props.onFacilityChange}
            key={facility.facilityName}
          />
        ))}
      </div>
    );
  }
}
export default RadioList;
